export default __webpack_public_path__ + "static/media/foto1.c7046748.jpg";